import { render } from "./ConfiguracaoInicialIndex.vue?vue&type=template&id=daa5c6a8&scoped=true&ts=true"
import script from "./ConfiguracaoInicialIndex.vue?vue&type=script&lang=ts"
export * from "./ConfiguracaoInicialIndex.vue?vue&type=script&lang=ts"

import "./ConfiguracaoInicialIndex.vue?vue&type=style&index=0&id=daa5c6a8&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daa5c6a8"]])

export default __exports__